import type { FC } from "react";
import { Avatar, type SxProps, type Theme } from "@mui/material";

export interface UserAvatarProps {
  userId: string;
  /** URL аватара пользователя */
  avatarUrl?: string | null;
  /** Размер аватара */
  size?: number;
  /** Дополнительные стили */
  sx?: SxProps<Theme>;
}

export const UserAvatar: FC<UserAvatarProps> = ({
  userId,
  avatarUrl,
  size,
  sx,
}) => {
  const fallbackUrl = `https://api.dicebear.com/7.x/thumbs/svg?seed=${encodeURIComponent(userId)}`;

  return (
    <Avatar
      src={avatarUrl || fallbackUrl}
      sx={{
        width: size,
        height: size,
        ...sx,
      }}
    />
  );
};
